import type { AitypesInsight } from '@polaris/api-client'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/src/utils/styles'
import { InsightCardBackground } from './insight-card-background'
import { InsightCardVisualization } from './insight-card-visualisation'

const insightImageVariants = cva(
  'flex flex-col justify-center items-center gap-3 relative',
  {
    variants: {
      variant: {
        featured: 'aspect-video w-full min-h-48 max-h-80 sm:min-h-80 sm:h-full',
        card: 'w-[104px] h-[104px] min-w-[104px] max-w-[104px] min-h-[104px] max-h-[104px]',
        article: 'w-[960px] h-[256px] lg:h-[400px] max-w-[960px]',
      },
    },
  },
)

const containerVariants = cva('flex w-full justify-center', {
  variants: {
    variant: {
      featured: 'rounded-2xl',
      card: 'rounded-xl',
      article: 'rounded-2xl',
    },
  },
  defaultVariants: {
    variant: 'featured',
  },
})

interface InsightImageProps extends VariantProps<typeof insightImageVariants> {
  insight: AitypesInsight
}

export function InsightImage({ insight, variant }: InsightImageProps) {
  return (
    <div className={cn(containerVariants({ variant }))}>
      {/* new-color-paletter class is used to namespace the color theme used for these cards */}
      <div className={insightImageVariants({ variant })}>
        <InsightCardBackground
          insight={insight}
          variant={variant}
          className={containerVariants({ variant })}
        />
        {insight.backgroundType === 'color' && (
          <div className='absolute inset-0 flex items-center justify-center'>
            <InsightCardVisualization insight={insight} variant='responsive' />
          </div>
        )}
      </div>
    </div>
  )
}
